import { FC } from "react";
import { AnyTask, Point } from "tm-shared/types";
import {
    isTaskAddPhoto,
    isTaskAssignment,
    isTaskAssortmentMatrix,
    isTaskDMP,
    isTaskPaidShelfSpace,
    isTaskPromoTagPhotos,
    isTaskRejectProducts,
    isTaskSaleAdditional,
    isTaskSetGeoLocation,
    isTaskShelfSize,
    isTaskStartVisit,
    isTaskTakeDebt,
    isTaskUpdateMarketInfo,
    isTaskUpdateProductBalances,
} from "tm-shared/utils";

import { AddPhotoViewModal } from "../AddPhotoViewModal";
import { AssignmentViewModal } from "../AssignmentViewModal";
import { AssortmentMatrixViewModal } from "../AssortmentMatrixViewModal";
import { DmpViewModal } from "../DmpViewModal";
import { PaidShelfSpaceViewModal } from "../PaidShelfSpaceViewModal";
import { PromoTagPhotosViewModal } from "../PromoTagPhotosViewModal";
import { RejectProductsViewModal } from "../RejectProductsViewModal";
import { SaleViewModal } from "../SaleViewModal";
import { SetGeoLocationViewModal } from "../SetGeoLocationViewModal";
import { ShelfSizeViewModal } from "../ShelfSizeViewModal";
import { StartVisitViewModal } from "../StartVisitViewModal";
import { TakeDebtViewModal } from "../TakeDebtViewModal";
import { UpdateMarketInfoViewModal } from "../UpdateMarketInfoViewModal";
import { UpdateProductBalancesViewModal } from "../UpdateProductBalancesViewModal";

interface TaskViewModalsContainerProps {
    modal: {
        task: AnyTask;
        point: Point;
    } | null;
    onClose: () => void;
}

export const TaskViewModalsContainer: FC<TaskViewModalsContainerProps> = ({
    modal,
    onClose,
}) => {
    if (!modal) return null;

    const { task, point } = modal;

    if (isTaskStartVisit(task)) {
        return <StartVisitViewModal onClose={onClose} task={task} />;
    }

    if (isTaskSaleAdditional(task)) {
        return <SaleViewModal onClose={onClose} task={task} />;
    }

    if (isTaskUpdateProductBalances(task)) {
        return <UpdateProductBalancesViewModal onClose={onClose} task={task} />;
    }

    if (isTaskTakeDebt(task)) {
        return <TakeDebtViewModal onClose={onClose} task={task} />;
    }

    if (isTaskUpdateMarketInfo(task)) {
        return (
            <UpdateMarketInfoViewModal
                onClose={onClose}
                task={task}
                point={point}
            />
        );
    }

    if (isTaskShelfSize(task)) {
        return <ShelfSizeViewModal onClose={onClose} task={task} />;
    }

    if (isTaskSetGeoLocation(task)) {
        return <SetGeoLocationViewModal onClose={onClose} task={task} />;
    }

    if (isTaskDMP(task)) {
        return <DmpViewModal onClose={onClose} task={task} point={point} />;
    }

    if (isTaskPromoTagPhotos(task)) {
        return (
            <PromoTagPhotosViewModal
                onClose={onClose}
                task={task}
                point={point}
            />
        );
    }

    if (isTaskPaidShelfSpace(task)) {
        return <PaidShelfSpaceViewModal onClose={onClose} task={task} />;
    }

    if (isTaskAssignment(task)) {
        return (
            <AssignmentViewModal onClose={onClose} task={task} point={point} />
        );
    }

    if (isTaskAssortmentMatrix(task)) {
        return (
            <AssortmentMatrixViewModal
                onClose={onClose}
                task={task}
                point={point}
            />
        );
    }

    if (isTaskAddPhoto(task)) {
        return <AddPhotoViewModal onClose={onClose} task={task} />;
    }

    if (isTaskRejectProducts(task)) {
        return <RejectProductsViewModal onClose={onClose} task={task} />;
    }
};
